import type { ReactNode } from 'react';
import { Text } from './Text';
import { IconChevronLeft } from '@/components/icons';
import { colors } from '@/theme/tokens';
import styles from './AppBar.module.css';

interface AppBarProps {
  title: string;
  /** Small line under the title, e.g. a customer's phone number. */
  subtitle?: ReactNode;
  /** Shows the back chevron. Stack sub-screens use it; top-level tabs do not. */
  onBack?: () => void;
  /** Sits before the title — the app-bar logo mark on Home. */
  leading?: ReactNode;
  right?: ReactNode;
}

/** Navy screen header. Absorbs the status-bar inset so screens never double-pad. */
export function AppBar({ title, subtitle, onBack, leading, right }: AppBarProps) {
  return (
    <header className={styles.bar}>
      <div className={styles.left}>
        {onBack ? (
          <button type="button" aria-label="ກັບຄືນ" onClick={onBack} className={styles.back}>
            <IconChevronLeft size={24} />
          </button>
        ) : null}
        {leading}
        <div className={styles.titles}>
          <Text weight={800} size={17} color={colors.onDark} lines={1}>
            {title}
          </Text>
          {subtitle}
        </div>
      </div>
      {right}
    </header>
  );
}
